exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 999999;\r\n  pointer-events: none;\r\n}\r\n\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 999999;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  box-sizing: border-box;\r\n  background: rgba(255, 255, 255, 0.38);\r\n  -webkit-backdrop-filter: blur(10px);\r\n          backdrop-filter: blur(10px);\r\n  pointer-events: auto;\r\n}\r\n\r\n.loader-overlay img {\r\n  display: block;\r\n  width: 150px;\r\n  height: 150px;\r\n  max-width: 40vw;\r\n  max-height: 40vh;\r\n  -o-object-fit: contain;\r\n     object-fit: contain;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixsloader/ixsloader.css
// module id = 1104
// module chunks = 320